import { AuthRoute } from '@/src/routes/routes.components'
import { LayoutMain } from '@layouts/LayoutMain/LayoutMain'
import { INSIGHTS_BASE_ROUTE, INSIGHTS_RECOMMENDATIONS_ROUTE, INSIGHTS_SETTINGS_ROUTE, TABS } from '@utils/constants'
import { Suspense, lazy } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { InsightsAdminRoute } from './InsightsAdminRoute'

const InsightInboxScreenLazy = lazy(() => import('./InsightInboxScreen'))
const InsightInboxPageLazy = lazy(() => import('./InsightInbox.page'))
const InsightSettingsPageLazy = lazy(() => import('./settings/InsightSettings.page'))
const InsightRecommendationsPageLazy = lazy(() => import('./settings/recommendations/InsightRecommendations.page'))

const InsightInboxScreen = (
  <Suspense fallback={<div />}>
    <InsightInboxScreenLazy />
  </Suspense>
)

const InsightInboxPage = (
  <Suspense fallback={<div />}>
    <InsightInboxPageLazy />
  </Suspense>
)

const InsightSettingsPage = (
  <Suspense fallback={<div />}>
    <InsightSettingsPageLazy />
  </Suspense>
)

const InsightRecommendationsPage = (
  <InsightsAdminRoute>
    <Suspense fallback={<div />}>
      <InsightRecommendationsPageLazy />
    </Suspense>
  </InsightsAdminRoute>
)

export const insightInboxRoutes: RouteObject[] = [
  {
    path: INSIGHTS_BASE_ROUTE,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      { path: '', element: <Navigate replace to={TABS.insightInbox.new} /> },
      // Declared before the `:status` route so "settings" is not read as a tab.
      { path: INSIGHTS_SETTINGS_ROUTE.replace(`${INSIGHTS_BASE_ROUTE}/`, ''), element: InsightSettingsPage },
      { path: INSIGHTS_RECOMMENDATIONS_ROUTE.replace(`${INSIGHTS_BASE_ROUTE}/`, ''), element: InsightRecommendationsPage },
      {
        element: InsightInboxScreen,
        children: [{ path: ':status', element: InsightInboxPage }],
      },
    ],
  },
]
